import { DownloadIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Badge } from '@/shared/components/ui/badge'
import { Button } from '@/shared/components/ui/button'
import { Footer } from '@/shared/components/ui/layout'
import {
	PaginationControlled,
	usePagination,
} from '@/shared/components/ui/pagination-controlled'
import { useLocationQuery } from '@/shared/hooks/useLocationQuery'

import { useAnchorsManagementContext } from './AnchorManagementProvider'

export default function AnchorManagementPageFooter() {
	const { t } = useTranslation()

	const { handleExportReportClick, anchors } = useAnchorsManagementContext()
	const [{ limit, offset }, setQuery] = useLocationQuery()
	const pagination = usePagination({
		total: anchors?.total ?? 0,
		limit: Number(limit),
		offset: Number(offset),
		onChange: setQuery,
	})

	return (
		<Footer className='h-8 grow-0 items-center justify-between py-3'>
			<PaginationControlled className='m-0 w-auto' pagination={pagination} />
			<div className='flex items-center space-x-2'>
				<Badge size='sm'>
					{t('app.items_on_page')}: {anchors?.data?.length || 0}
				</Badge>
				<Badge size='sm'>
					{t('app.total_items')}: {anchors?.total || 0}
				</Badge>
				<Button
					size='sm'
					disabled={!anchors?.total}
					className='py-0'
					onClick={handleExportReportClick}
				>
					<DownloadIcon />
					{t('app.download_table')}
				</Button>
			</div>
		</Footer>
	)
}
